import { useForm } from 'react-hook-form';
import { FORM_CLAIM_LIST, searchDefaultValues } from '../form';
import { exportHeaders, exportBlankFields } from '../columns';
import { useGetClaimFull } from './useGetClaimFull';
import { useCallback, useEffect, useState } from 'react';
import { useClaimDate } from './useClaimDate';
import { useApproveClaim } from './useApproveClaim';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { navigateTo } from '../../../../utils/navigation';
import { useModal } from '../../../../components/modal/hooks/useModal';
import { useShipment } from './useShipment';

// จำนวนช่องยี่ห้อ/รุ่นมือถือที่ export (ตรงกับ exportHeaders)
const MOBILE_EXPORT_SLOTS = 3;

export const useGetClaimList = () => {
  const [searchType, setSearchType] = useState(null);
  const [claimData, setClaimData] = useState(null);
  const { open: openProcessStatus, onToggle: onToggleProcessStatus } = useModal();
  const { open: openTracking, onToggle: onToggleTracking } = useModal();
  const { open: openLine, onToggle: onToggleLine } = useModal();
  const { open: openRemark, onToggle: onToggleRemark } = useModal();
  const formSearchObj = useForm({ defaultValues: searchDefaultValues || location.state });
  const searchParamState = formSearchObj.watch();
  const { handleSubmit } = formSearchObj;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isInitialFetch, setIsInitialFetch] = useState(true);

  const {
    loading: loadingClaimFull,
    onFetchFull: onFetchClaimFull,
    dataSource: dataClaimFull,
  } = useGetClaimFull({ handleSubmit: formSearchObj.handleSubmit });

  const {
    loading: loadingClaimDate,
    onFetch,
    data: dataClaimDate,
  } = useClaimDate({ setSelectedRowKeys, searchParamState });

  useEffect(() => {
    if (location.state && isInitialFetch) {
      formSearchObj.handleSubmit(onFetch)();
      setIsInitialFetch(false);
    } else {
      onFetch(searchDefaultValues);
    }
  }, [location.state, isInitialFetch]);

  const onOpenClaimView = (record) => {
    const url = `${ROUTES_PATH.ROUTE_CLAIM_VIEW.PATH}?code=${record.claimCode}`;
    window.open(url, '_blank');
  };
  const onOpenClaimEdit = (record) => {
    const url = `${ROUTES_PATH.ROUTE_CLAIM_VIEW.PATH}?code=${record.claimCode}`;
    window.open(url, '_blank');
  };

  const onModalProcessStatus = (record) => {
    setClaimData(record);
    onToggleProcessStatus({ defaultValues: record });
  };
  const onOpenTracking = (record) => {
    setClaimData(record);
    onToggleTracking({ defaultValues: record });
  };
  const onOpenLineMessage = (record) => {
    setClaimData(record);
    onToggleLine({ defaultValues: record });
  };
  const onOpenRemarkMessage = (record) => {
    setClaimData(record);
    onToggleRemark({ defaultValues: record });
  };

  const { mutate: onSubmitApproveClaim, loading: isLoadingApprove } = useApproveClaim({
    selectedRowKeys,
    onSuccessCallback: () => {
      searchType === 'search' ? onFetchFull() : onFetch();
    },
  });

  const { mutate: onSubmitShipment, loading: isLoadingShipment } = useShipment({
    selectedRowKeys,
  });

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onSearchByField = (values) => {
    if (values.search) {
      setSearchType('search');
      onFetchClaimFull(values);
    } else if (values.startDate) {
      setSearchType('date');
      onFetch(values);
    }
  };
  const handleSubmitAccident = () => {
    onSubmitApproveClaim();
  };
  const handleSubmitShipment = () => {
    onSubmitShipment(selectedRowKeys);
  };

  const gotoclaimAdd = useCallback(() => {
    navigateTo({ pathname: ROUTES_PATH.ROUTE_CLAIM_ADD.PATH });
  }, []);
  // กระจาย mobiles (หลายเครื่องต่อ 1 การลงทะเบียน) เป็นคอลัมน์ ยี่ห้อ/รุ่น ช่องที่ 1-3
  const flattenMobiles = (item) => {
    const mobiles =
      Array.isArray(item?.mobiles) && item.mobiles.length
        ? item.mobiles
        : [{ mobileBrandName: item?.mobileBrandName, mobileModelName: item?.mobileModelName }];

    return Object.fromEntries(
      Array.from({ length: MOBILE_EXPORT_SLOTS }).flatMap((_, index) => {
        const suffix = index === 0 ? '' : `${index + 1}`;
        return [
          [`mobileBrandName${suffix}`, mobiles[index]?.mobileBrandName ?? ''],
          [`mobileModelName${suffix}`, mobiles[index]?.mobileModelName ?? ''],
        ];
      }),
    );
  };

  // สร้างแถว Excel จาก exportHeaders โดยตรง คอลัมน์ที่แบรนด์นี้ไม่มีข้อมูลจะเว้นว่าง
  const transformDataForExcel = (data) =>
    (data ?? []).map((item) => {
      const row = { ...item, ...flattenMobiles(item) };
      return Object.fromEntries(
        exportHeaders.map(({ dataIndex }) => [
          dataIndex,
          exportBlankFields.includes(dataIndex) ? '' : row?.[dataIndex] ?? '',
        ]),
      );
    });

  const formSearch = FORM_CLAIM_LIST({ onEnter: formSearchObj.handleSubmit(onSearchByField) });

  return {
    formSearch,
    formSearchObj,
    loadingClaimFull,
    onFetchClaimFull,
    dataClaimFull,
    handleSubmit,
    searchType,
    onFetch,
    loadingClaimDate,
    dataClaimDate,
    setSelectedRowKeys,
    onSearchByField,
    searchDefaultValues,
    handleSubmit,
    selectedRowKeys,
    onSelectChange,
    gotoclaimAdd,
    handleSubmitAccident,
    transformDataForExcel,
    onOpenClaimView,
    onOpenClaimEdit,
    onModalProcessStatus,
    openProcessStatus,
    onToggleProcessStatus,
    claimData,
    onFetch,
    onOpenTracking,
    openTracking,
    onToggleTracking,
    handleSubmitShipment,
    openLine,
    onToggleLine,
    onOpenLineMessage,
    openRemark,
    onToggleRemark,
    onOpenRemarkMessage,
    isLoadingApprove,
    isLoadingShipment,
  };
};
